import type { FaireProductEntity } from "../../entity_types/product";

export const p_g5ja78tprq: FaireProductEntity = {
  token: "p_g5ja78tprq",
  type: "product",
  name: "Breast Health | 10 ml",
  brandToken: "b_5dagse75md",
  brandName: "Rowe Casa Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/787f1a66736fcb862e8fdf4e3b7a8649e5ec2344f86c4c6cbd187e0d4aadaeee.png",
  galleryImageUrls: [],
  priceDollars: 16.8,
  description:
    "Feel supported, comforted, and balanced, naturally. At Rowe Casa, we care deeply about supporting your wellbeing from head to toe– and that includes breast care. Featuring 100% therapeutic grade essential oils, this thoughtfully formulated blend aims to help support and balance hormones that are essential in supporting healthy breasts while also aiding with other breast challenges such as pain. \n\n\nFor more product information or questions on products, please join our VIP group on Facebook. ",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:46.909Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
